if (!customElements.get('cabane-request-slider')) {
  customElements.define('cabane-request-slider', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.slides = [...this.querySelectorAll('.cabane-request-slider__slide')];
      this.dots = [...this.querySelectorAll('[data-slide]')];
      this.toggle = this.querySelector('.cabane-request-slider__toggle');
      this.index = 0;
      this.paused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.dots.forEach((button, index) => button.addEventListener('click', () => {
        this.paused = true;
        this.show(index);
        this.sync();
      }));
      this.toggle.addEventListener('click', () => { this.paused = !this.paused; this.sync(); });
      this.addEventListener('mouseenter', () => { this.hovered = true; this.sync(); });
      this.addEventListener('mouseleave', () => { this.hovered = false; this.sync(); });
      this.addEventListener('focusin', () => { this.focused = true; this.sync(); });
      this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) { this.focused = false; this.sync(); } });
      this.visibility = () => this.sync();
      document.addEventListener('visibilitychange', this.visibility);
      this.sync();
    }
    show(index) {
      this.index = index;
      this.slides.forEach((slide, i) => { slide.hidden = i !== index; });
      this.dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === index)));
    }
    sync() {
      clearInterval(this.timer);
      this.toggle.setAttribute('aria-label', this.paused ? 'Reprendre le défilement' : 'Mettre le défilement en pause');
      this.toggle.firstElementChild.textContent = this.paused ? '▶' : 'Ⅱ';
      if (!this.paused && !this.hovered && !this.focused && !document.hidden) {
        this.timer = setInterval(() => this.show((this.index + 1) % this.slides.length), 6000);
      }
    }
    disconnectedCallback() { clearInterval(this.timer);document.removeEventListener('visibilitychange', this.visibility);this.ready = false; }
  });
}